<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">
    {{'bikeshop.text_message_integration.modal_header' | translate }}
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span class="hubtiger-close"></span>
  </button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-md-12">
      <div *ngIf="partner && selectTextMessagePlatform === 3">
        <app-link-twilio [partner]="partner" (onConnected)="onConnected()"></app-link-twilio>
      </div>

        <div *ngIf="partner && selectTextMessagePlatform === 4">
        <app-link-coax [partner]="partner" (onConnected)="onConnected()"></app-link-coax>
      </div>
    </div>
  </div>
</div>
